//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import cookie from 'cookie';

export default {
    created: function created() {
        var _this = this;

        if (process.client) {
            var parsedCookies = cookie.parse(document.cookie);
            var utmLang = parsedCookies.utm_language ? parsedCookies.utm_language : 'en';

            var thisRef = this;
            axios.get(global.websiteSettings.extra_info.api_endpoint + 'api/tpay' + this.$route.fullPath /*, {headers: {'X-Cookie': this.getAllCookies()}}*/).then(function (res) {
                if (res.data) {
                    _this.$auth.setToken(res.data.access_token, res.data.refresh_token, res.data.token_type, res.data.expires_in);
                    _this.$parent.$emit('login-logout-event');
                }
                //this.$router.push({name: 'index'});
                _this.$router.push({ name: 'lang-successful-signup', params: { lang: utmLang } });
            });
        }
    },


    methods: {
        getAllCookies: function getAllCookies() {
            if (process.client) {
                return document.cookie;
            }
            return '';
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/subscription-check.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/subscription-check.vue
// module chunks = 45